import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { BaseEntryProductComponent } from '@products/base-entry-product-component';
import { ProductDetailConfiguration } from '@types';
import { Logger } from '@utils/logger';
import { FundPerformanceComponentConfig } from '../fund-performance-component.config';
import { FundPerformanceDisplayComponent } from '../fund-performance-display-component.interface';
const logger = Logger.getLogger('FundPerformanceEntryComponent');

@Component({
  selector: 'ft-fund-performance-entry',
  templateUrl: './fund-performance-entry.component.html',
  styleUrls: ['./fund-performance-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundPerformanceEntryComponent
  extends BaseEntryProductComponent
  implements OnInit, OnDestroy {
  @ViewChild('dynamicCmp', { read: ViewContainerRef, static: false }) container;
  componentType: string;
  componentRef: ComponentRef<FundPerformanceDisplayComponent>;
  componentConfig: FundPerformanceComponentConfig;
  isLoading = true;
  errorMsg: string;
  public containerWideClass: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    const brConfig: ProductDetailConfiguration = this.component.getModels()
      ?.config;
    this.componentType = brConfig?.componentType;
    this.containerWideClass = this.brConfig?.hasContainerWideClass;
    this.componentConfig = FundPerformanceComponentConfig.getConfig(
      this.componentType,
      this.configurationName
    );
    this.changeDetector.detectChanges(); // at this point show component if componentType exists

    if (this.componentConfig) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.componentConfig.component
      );
      this.container.clear();
      this.componentRef = this.container.createComponent(componentFactory);
      this.isLoading = false;
      this.errorMsg = null;

      this.componentRef.instance.populate(
        this.componentConfig,
        brConfig,
        this.component,
        this.page
      );
      this.changeDetector.detectChanges(); // to remove loading message
    } else {
      logger.error(
        'No component found: ',
        this.componentType,
        this.configurationName
      );
      this.errorMsg = `No component found: ${this.componentType}, ${this.configurationName}`;
    }
  }

  ngOnDestroy() {
    // clean up dynamic component to avoid memory leaks
    this.componentRef?.destroy();
  }
}
